<div class="row">
  <div class="col-12">
    <h4>{{ user }}’s {{ selectedSport }} Pick History</h4>
    <div class="bg-white p-3 rounded-10">
      <div class="kingpin-table">
        <div class="table-row header blue">
          <div class="cell">Match date</div>
          <div class="cell">Game</div>
          <div class="cell">Pick</div>
          <div class="cell">Amount</div>
          <div class="cell">Result</div>
          <div class="cell text-md-end">Amount Won/Lost</div>
        </div>

        <div class="table-row" *ngFor="let item of history">
          <div class="cell" data-title="Match date">{{ item.match_date }}</div>
          <div class="cell" data-title="Game">
            {{ item.teams }}
          </div>
          <div class="cell" data-title="pick">
            {{ item.team_bet }}
          </div>
          <div class="cell fw-bold" data-title="Amount">
            {{ item.bet_amount | CustomCurrency }}
          </div>
          <div
            class="cell fw-bold small"
            data-title="Result"
            [class.text-danger]="item.win_loss_amount < 0"
            [class.text-success]="item.win_loss_amount > 0"
          >
            {{ item.result | titlecase }}
          </div>
          <div
            class="cell fw-bold text-md-end"
            data-title="Amount won/lost"
            [class.text-danger]="item.win_loss_amount < 0"
            [class.text-success]="item.win_loss_amount > 0"
          >
            {{ item.win_loss_amount | CustomCurrency }}
          </div>
        </div>
      </div>
    </div>
    <div class="text-center my-4" *ngIf="filter.get('page') == 'true'">
      <button
        #button
        class="btn btn-theme"
        type="button"
        (click)="loadMore(button)"
      >
        Load More
      </button>
    </div>
  </div>
</div>
